angular.module('app.controllers.sceneAddWidget', [])
    .config(['$stateProvider', function ($stateProvider) {
        'ngInject';
        
        $stateProvider
            .state('scene.edit.addWidget', {
                url: '/add',
                abstract: true,
                parent: 'scene.edit',
                template: '<ui-view></ui-view>',
                params: {
                    Action: null,
                    Condition: null,
                    Parent: null,
                    Top: null,
                    AddNew: null
                }


            });



    }])




